var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4078 14.8157C13.7376 14.8157 14.8157 13.7376 14.8157 12.4078C14.8157 11.078 13.7376 10 12.4078 10C11.078 10 10 11.078 10 12.4078C10 13.7376 11.078 14.8157 12.4078 14.8157Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0911 16.6407V29.9993H21.2388V23.3932C21.2388 21.65 21.5668 19.9619 23.7281 19.9619C25.8597 19.9619 25.8861 21.9549 25.8861 23.5032V30.0004H30.036V22.6746C30.036 19.076 29.2613 16.3105 25.0553 16.3105C23.0359 16.3105 21.6823 17.4187 21.1288 18.4675H21.0727V16.6407H17.0911ZM10.332 16.6407H14.4863V29.9993H10.332V16.6407Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWLinkedin);
export default __webpack_public_path__ + "static/media/w_linkedin.b62bebf908f30a2112a07cf20bdbcebd.svg";
export { ForwardRef as ReactComponent };